import { Grid, keyframes, Typography, useTheme } from '@mui/material';
import { t } from 'i18next';
import CreatePasswordForm from './CreatePasswordForm';
import Logo from '../../components/Common/Logo';

const slideInSun = keyframes`
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
`;

function CreatePassword() {
  const theme = useTheme();
  const currentYear = new Date().getFullYear();

  return (
    <Grid
      display="flex"
      flexDirection="column"
      alignItems="center"
      minHeight="100vh"
      gap={1}
      sx={{
        background: 'linear-gradient(163deg, #FFF 10.13%, #FFF4F0 89.18%)',
        overflow: 'hidden',
        position: 'relative',
        width: '100%',
      }}
      justifyContent="space-between"
    >
      <Grid
        mt={1}
        position="relative"
        display="flex"
        alignItems="center"
        justifyContent="center"
        width="100%"
      >
        <Grid sx={{ animation: `${slideInSun} 0.8s ease forwards` }}>
          <Logo />
        </Grid>
      </Grid>

      <Grid
        container
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap={2}
        flexGrow={1}
        px={2}
      >
        <Grid
          item
          xs={12}
          sm={8}
          md={4}
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          gap={2.5}
          bgcolor="#fff"
          borderRadius={2}
          boxShadow={theme.borderStyles.cardBorders}
          border="1px solid #FEE4DB"
          width="100%"
          maxWidth={400}
          p={3}
          zIndex={1}
        >
          <CreatePasswordForm />
        </Grid>
      </Grid>

      <Typography variant="caption2Regular" textAlign="center" color="primary" mb={1} zIndex={2}>
        {currentYear} ProgressMagic. {t('common.allRightsReserved')}
      </Typography>
    </Grid>
  );
}

export default CreatePassword;
